import React, { Fragment, useEffect, useState } from "react";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDashboard, faFileLines, faTable } from "@fortawesome/free-solid-svg-icons";
import { VIEW_MODES } from "../../constants/appConstants";
interface SwitchViewDataProps {
    currentViewMode: string;
    setCurrentViewMode: (viewMode: string) => void;
}

const SwitchViewData: React.FC<SwitchViewDataProps> = ({ currentViewMode, setCurrentViewMode }) => {
    const [currentView, setCurrentView] = useState<string>(VIEW_MODES.DETAILED);
    useEffect(() => {
        setCurrentView(currentViewMode);
    }, [currentViewMode]);

    const handleViewChange = (view: string) => {
        setCurrentViewMode(view);
        setCurrentView(view);
    };

    const LIST_VIEW = [
        {
            display: <FontAwesomeIcon icon={faFileLines} size="2x" />,
            name: VIEW_MODES.DETAILED,
        },
        {
            display: <FontAwesomeIcon icon={faTable} size="2x" />,
            name: VIEW_MODES.TABLE,
        },
    ];
    return (
        <div className="wrapper_view">
            <div className="toggle_radio_view">
                {LIST_VIEW.map((view) => (
                    <Fragment key={view.name}>
                        <input
                            type="radio"
                            className="toggle_option_view"
                            id={`view_${view.name}`}
                            name="toggle_option_view"
                            checked={view.name === currentView ? true : false}
                        />
                        <label
                            className={`view_${view.name}`}
                            htmlFor={`view_${view.name}`}
                            onClick={() => {
                                handleViewChange(view.name);
                            }}
                        >
                            {view.display}
                        </label>
                    </Fragment>
                ))}
                <div className="toggle_option_slider_view"></div>
            </div>
        </div>
    );
};

export default SwitchViewData;
